import { render, staticRenderFns, recyclableRender, components } from "./u-swipe-action-item.vue?vue&type=template&id=353c51ae&scoped=true&filter-modules=eyJ3eHMiOnsidHlwZSI6InNjcmlwdCIsImNvbnRlbnQiOiIiLCJzdGFydCI6MjIyMiwiYXR0cnMiOnsic3JjIjoiLi9pbmRleC53eHMiLCJtb2R1bGUiOiJ3eHMiLCJsYW5nIjoid3hzIn0sImVuZCI6MjIyMn19&"
var renderjs
import script from "./u-swipe-action-item.vue?vue&type=script&lang=js&"
export * from "./u-swipe-action-item.vue?vue&type=script&lang=js&"
import style0 from "./u-swipe-action-item.vue?vue&type=style&index=0&id=353c51ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Ruanjian/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c51ae",
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./index.wxs?vue&type=custom&index=0&blockType=script&issuerPath=D%3A%5CWenJian%5CMin%5C%E5%BE%AE%E4%BF%A1%E5%B0%8F%E7%A8%8B%E5%BA%8F%5Cunattended-app%5Cuni_modules%5Cuview-ui%5Ccomponents%5Cu-swipe-action-item%5Cu-swipe-action-item.vue&module=wxs&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "uni_modules/uview-ui/components/u-swipe-action-item/u-swipe-action-item.vue"
export default component.exports